import React from "react";
import NotificationPreferencesCommon from "@/features/settings/NotificationPreferencesCommon.jsx";

export default function NotificationsNews() {
  return <NotificationPreferencesCommon role="patient" />;
}
